import { FC } from 'react';
import { IRecording } from '../../recording/RecordingState';
import { Text } from '../../components/Text';
import { AIIcon } from '../../theme/Icons';

export type INotesListSummarizedByAIProps = {
    recording?: IRecording;
};

export const NotesListSummarizedByAI: FC<INotesListSummarizedByAIProps> = ({ recording }) => {
    const summary = recording?.summary;
    const isUnavailable = summary?.isUnavailable === true;
    const textColor = 'var(--ion-color-step-600, #666666)';

    return summary && (
        <div style={{display: 'flex', alignItems: 'center', gap: 4, color: textColor}} data-id="ai-summary-indicator">
            <Text>
                <div style={{fontSize: 14}} data-id="ai-summary-text">{isUnavailable ? 'Summary Unavailable' : 'AI Summary'}</div>
            </Text>
            <div style={{opacity: isUnavailable ? 0.5 : 1}}>
                <AIIcon color={isUnavailable ? 'medium' : 'primary'} />
            </div>
        </div>
    );
};
